import React, { useState } from "react";
import Icon from "./Icon";

const FooterNavButton = ({ type, label, onClick, active, disabled }) => {
  const [hover, setHover] = useState(false);

  const style = {
    height: "34px",
    width: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
    cursor: disabled ? "not-allowed" : "pointer",
    userSelect: "none",
    transition: "all 0.2s ease",
    backgroundColor: disabled ? "#f3f4f6" : (active ? "#e0e7ff" : hover ? "#f3f4f6" : "#ffffff"),
    color: disabled ? "#9ca3af" : (active ? "#4f46e5" : hover ? "#4f46e5" : "#374151"),
    border: disabled ? "1px solid #e5e7eb" : (active ? "1px solid #c7d2fe" : "1px solid #e5e7eb"),
    opacity: disabled ? 0.6 : 1
  };

  const iconWrapper = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 0,
  };

  const iconStyle = {
    height: "15px",
    width: "15px",
    display: "block",
  };

  const handleClick = () => {
    if (!disabled && onClick) {
      onClick();
    }
  };

  return (
    <div
      onClick={handleClick}
      style={style}
      onMouseEnter={() => !disabled && setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div style={iconWrapper}>
        {type === "text" ? (
          label
        ) : (
          <Icon type={type} style={iconStyle} />
        )}
      </div>
    </div>
  );
};

export default FooterNavButton;